import { Helmet } from 'react-helmet';

const SEO = ({ title, description, keywords, ogImage, canonicalUrl, structuredData }) => {
    const defaultTitle = "Galle Ceylon Spices International - Premium Sri Lankan Cinnamon & Spices";
    const defaultDescription = "Discover Galle Ceylon Spices International, a leader in premium Sri Lankan spices since 1990. Explore our organic cinnamon sticks, powders, and blends under Ceylon Spice Essence. Sustainable farming, quality spices, and global export from Elpitiya, Sri Lanka.";
    const defaultKeywords = "Galle Ceylon Spices, Sri Lankan spices, cinnamon products, organic cinnamon, spice export, Ceylon Spice Essence, premium spices, sustainable farming, global spice trade, quality spices, cinnamon sticks, cinnamon powder, spice blends, spice industry, Elpitiya Sri Lanka";
    const defaultOgImage = "%PUBLIC_URL%/logo.png";
    const siteUrl = "https://www.galleceylonspices.com";

    return (
        <Helmet>
            <title>{title || defaultTitle}</title>
            <meta name="description" content={description || defaultDescription} />
            <meta name="keywords" content={keywords || defaultKeywords} />
            <meta name="author" content="Galle Ceylon Spices International (Pvt) Ltd" />
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href={canonicalUrl || siteUrl} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={title || defaultTitle} />
            <meta property="og:description" content={description || defaultDescription} />
            <meta property="og:url" content={canonicalUrl || siteUrl} />
            <meta property="og:image" content={ogImage || defaultOgImage} />
            <meta property="og:site_name" content="Galle Ceylon Spices International" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title || defaultTitle} />
            <meta name="twitter:description" content={description || defaultDescription} />
            <meta name="twitter:image" content={ogImage || defaultOgImage} />
            {structuredData && (
                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            )}
        </Helmet>
    );
};

export default SEO;